(function () {
    "use strict";

    angular.module("app")
        .config([
            "$provide", "$httpProvider",
            function ($provide, $httpProvider) {

                $provide.factory("authenticationFailureHttpInterceptor", [
                    '$q', 'bus', 'authenticationEvents',
                    function ($q, bus, authenticationEvents) {
                        return {
                            responseError: function (rejection) {
                                if (rejection.status === 401) {
                                    bus.publish(authenticationEvents.logoutSuccess);
                                }

                                return $q.reject(rejection);
                            }
                        };
                    }]);

                $httpProvider.interceptors.push("authenticationFailureHttpInterceptor");
            }
        ]);
}());